import toast from "./toast.js";
import { exposeFunctions } from "./core.js";
import { _fetch, sendData, showProblemDetail } from 'spart/js/fetch.js';

function urlBase64ToUint8Array(str) {
	const base64 = str.replace(/-/g, '+').replace(/_/g, '/');

	const rawData = window.atob(base64);
	const outputArray = new Uint8Array(rawData.length);

	for (let i = 0; i < rawData.length; ++i) {
		outputArray[i] = rawData.charCodeAt(i);
	}
	return outputArray;
}

const pnInfoKey = 'pushNotificationInfo';

export async function registerPushNotification(force) {
	if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
		toast('Push notifications are not supported in this browser.');
		return false;
	}

	const current = window.localStorage.getItem(pnInfoKey);

	try {
		const registration = await navigator.serviceWorker.ready;

		let response = await _fetch('/api/session/webpush-vapid-public-key');
		if (!response.ok) {
			console.error('Failed to fetch the VAPID public key');
			await showProblemDetail(response);
			return false;
		}

		const publicKey = await response.text();
		const convertedVapidKey = urlBase64ToUint8Array(publicKey);

		const subscription = await registration.pushManager.subscribe({
			userVisibleOnly: true,
			applicationServerKey: convertedVapidKey
		});

		const pnToken = JSON.stringify(subscription);
		if (!force && current == pnToken) {
			return true; // PN token has not changed
		}

		response = await sendData('/api/session/register-push-notification', 'POST', subscription);

		if (response.ok) {
			window.localStorage.setItem(pnInfoKey, pnToken);
			console.log('Push notification successfully registered.');
			return true;
		} else {
			console.error('Failed to register push notification token with backend.');
			await showProblemDetail(response);
			return false;
		}
	}
	catch (err) {
		console.error('Error during push notification registration:', err);
		if (!current)
			toast('Error during push notification registration');
		return false;
	}
}

export async function cancelPushNotification() {
	if (!window.localStorage.getItem(pnInfoKey)) {
		console.warn('No push notification registered so no cancellation.');
		return true;
	}
	try {
		const response = await _fetch('/api/session/cancel-push-notification', { method: 'POST' });
		if (response.ok) {
			window.localStorage.removeItem(pnInfoKey);
			console.log('Push notification successfully cancelled.');
			return true;
		}
		else {
			console.error('Failed to cancel push notification token with backend.');
			await showProblemDetail(response);
			return false;
		}
	}
	catch (err) {
		console.error('Error during push notification cancellation:', err);
		toast('Error during push notification cancellation');
		return false;
	}
}

exposeFunctions({ registerPushNotification, cancelPushNotification });

